/**
 * Flow D's offering routes (D1, D2). Mounted by the app shell; this package does not
 * edit `App.tsx`.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { D1Offering } from './D1Offering.js';
import { D2Compare } from './D2Compare.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (transaction · লেনদেন); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const offeringRoutes: RouteObject[] = withSurfaceStates('transaction', [
  { path: '/offering/:id', element: <D1Offering /> },
  { path: '/offering/:id/compare', element: <D2Compare /> },
]);
